import { createFileRoute } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { PageHero, ServicePageBody } from "@/components/site/PageShell";
import { BUSINESS } from "@/components/site/constants";

export const Route = createFileRoute("/soffit")({
  head: () => ({
    meta: [
      { title: "Soffit Repair & Installation in Citrus County, FL | Destination Roofing" },
      { name: "description", content: `Soffit and fascia repair, replacement, and installation in Citrus County, FL. Free Roof Inspection & Estimate. ${BUSINESS.phone}.` },
      { property: "og:title", content: "Soffit Repair & Installation in Citrus County, FL" },
      { property: "og:description", content: "Soffit and fascia repair and replacement in Citrus County, FL." },
      { property: "og:url", content: canonical("/soffit") },
    ],
    links: [{ rel: "canonical", href: canonical("/soffit") }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <PageHero showRating
        eyebrow="Soffit & Fascia"
        title="Soffit repair & installation in Citrus County, FL"
        subtitle="Soffit protects your attic and your rafter tails. When it fails, everything behind it fails too — quietly, over years."
      />
      <ServicePageBody title="Soffit" service="Soffit">
        <h2>What soffit does for your home</h2>
        <p>
          Soffit is the panel that closes off the underside of your roof overhang. In humid Florida, vented soffit is what allows your attic to breathe. When soffit gets damaged by water, wind, or animals, the attic can't ventilate properly and your fascia and rafter ends start to rot.
        </p>

        <h2>Soffit problems we repair</h2>
        <ul>
          <li>Sagging or fallen soffit panels</li>
          <li>Water damage from clogged or missing gutters</li>
          <li>Rodent, bird, or squirrel intrusion</li>
          <li>Damaged fascia behind the soffit</li>
          <li>Faded, peeling, or brittle vinyl soffit</li>
        </ul>

        <h2>Full soffit replacement</h2>
        <p>
          We install vented vinyl and aluminum soffit systems that match your fascia and drip edge. If you're already replacing your roof, that's the smartest time to redo any soffit that's showing its age.
        </p>
      </ServicePageBody>
    </>
  );
}
